module.exports = Object.freeze({
  TRACK_CHANGE: "track-change",
});
